import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import AboutPage from 'bundles/xddp/components/AboutPage';
import AcademicsPage from 'bundles/xddp/components/AcademicsPage';
import AdmissionsPage from 'bundles/xddp/components/AdmissionsPage';
import CareersPage from 'bundles/xddp/components/CareersPage';
import DegreeApp from 'bundles/xddp/components/DegreeApp';
import FinancialPage from 'bundles/xddp/components/FinancialPage';
import LandingPage from 'bundles/xddp/components/LandingPage';
import OverviewPage from 'bundles/xddp/components/OverviewPage';
import SpecializationPage from 'bundles/xddp/components/SpecializationPage';
import StudentExperiencePage from 'bundles/xddp/components/StudentExperiencePage';

const reactRoute = (
  <Route name="xddp" path="/">
    <Route name="app" component={DegreeApp} path="degrees/:slug">
      <IndexRoute name="overview" component={OverviewPage} />

      <Route name="admisiones" component={AdmissionsPage} path="admisiones" />
      <Route name="costos-y-becas" component={FinancialPage} path="costos-y-becas" />
      <Route name="plan-de-estudios" component={AcademicsPage} path="plan-de-estudios" />
      <Route name="experiencia-del-estudiante" component={StudentExperiencePage} path="experiencia-del-estudiante" />
      <Route name="carreras-profesionales" component={CareersPage} path="carreras-profesionales" />
      <Route name="acerca" component={AboutPage} path="acerca" />

      <Route name="admissions" component={AdmissionsPage} path="admissions" />
      <Route name="tuition-financing" component={FinancialPage} path="tuition-financing" />
      <Route name="academics" component={AcademicsPage} path="academics" />
      <Route name="student-experience" component={StudentExperiencePage} path="student-experience" />
      <Route name="careers" component={CareersPage} path="careers" />
      <Route name="about" component={AboutPage} path="about" />

      <Route name="landing" component={LandingPage} path="landing" />
      <Route name="specialization" component={SpecializationPage} path=":specializationSlug" />
    </Route>

    <Route component={NotFound} path="*" />
  </Route>
);

export default reactRoute;
